import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  cardInfo: {
    backgroundColor: theme.palette.greenPantoneLight,
    padding: theme.spacing(3),
  },
}))

export default styles
